import { lazy } from 'react';

const Amenitie = lazy(() => import('./components/amenitie/Amenitie'));
const AmenitieForm = lazy(() => import('./components/amenitie/AmenitieForm'));
const AmenitieGroup = lazy(() => import('./components/amenitiegroup/AmenitieGroup'));
const AmenitieGroupForm = lazy(() => import('./components/amenitiegroup/AmenitieGroupForm'));
const Apartment = lazy(() => import('./components/apartment/Apartment'));
const ApartmentForm = lazy(() => import('./components/apartment/ApartmentForm'));
const ApartmentAmenitie = lazy(() => import('./components/apartmentamenitie/ApartmentAmenitie'));
const ApartmentAmenitieForm = lazy(() => import('./components/apartmentamenitie/ApartmentAmenitieForm'));
const Booking = lazy(() => import('./components/booking/Booking'));
const BookingForm = lazy(() => import('./components/booking/BookingForm'));
const House = lazy(() => import('./components/house/House'));
const HouseForm = lazy(() => import('./components/house/HouseForm'));
const Image = lazy(() => import('./components/image/Image'));
const ImageForm = lazy(() => import('./components/image/ImageForm'));
const Payment = lazy(() => import('./components/payment/Payment'));
const PaymentForm = lazy(() => import('./components/payment/PaymentForm'));
const User = lazy(() => import('./components/user/User'));
const UserForm = lazy(() => import('./components/user/UserForm'));
const Dashboard = lazy(() => import('./components/dashboard/Dashboard'));
const Calendar = lazy(() => import('./components/calendar/Calendar'));
const Curent = lazy(() => import('./components/booking/Curent'));
const Arrivals = lazy(() => import('./components/booking/Arrivals'));
const Search = lazy(() => import('./components/booking/Search'));

const routes = [
    // home roote
    { path: '/', element: <Dashboard /> },

    { path: '/dashboard', element: <Dashboard /> },
    { path: '/calendar', element: <Calendar /> },

    { path: '/amenitie', element: <Amenitie /> },
    { path: '/amenitie/new', element: <AmenitieForm /> },
    { path: '/amenitie/:id/edit', element: <AmenitieForm /> },

    { path: '/amenitiegroup', element: <AmenitieGroup /> },
    { path: '/amenitiegroup/new', element: <AmenitieGroupForm /> },
    { path: '/amenitiegroup/:id/edit', element: <AmenitieGroupForm /> },

    { path: '/apartment', element: <Apartment /> },
    { path: '/apartment/new', element: <ApartmentForm /> },
    { path: '/apartment/:id/edit', element: <ApartmentForm /> },

    { path: '/apartmentamenitie', element: <ApartmentAmenitie /> },
    { path: '/apartmentamenitie/new', element: <ApartmentAmenitieForm /> },
    { path: '/apartmentamenitie/:id/edit', element: <ApartmentAmenitieForm /> },

    { path: '/booking', element: <Booking /> },
    { path: '/booking/new', element: <BookingForm /> },
    { path: '/booking/:id/edit', element: <BookingForm /> },
    { path: '/curent', element: <Curent /> },
    { path: '/arrivals', element: <Arrivals /> },
    { path: '/search', element: <Search /> },

    { path: '/house', element: <House /> },
    { path: '/house/new', element: <HouseForm /> },
    { path: '/house/:id/edit', element: <HouseForm /> },

    { path: '/image', element: <Image /> },
    { path: '/image/new', element: <ImageForm /> },
    { path: '/image/:id/edit', element: <ImageForm /> },

    { path: '/payment', element: <Payment /> },
    { path: '/payment/new', element: <PaymentForm /> },
    { path: '/payment/:id/edit', element: <PaymentForm /> },

    { path: '/user', element: <User /> },
    { path: '/user/new', element: <UserForm /> },
    { path: '/user/:id/edit', element: <UserForm /> }
];

export default routes;
